import React from "react";
import { Link } from "react-router-dom";
import Announcement from "../components/Announcement";
import FixMenu from "../components/FixMenu";
import Header from "../components/Header";

const ContactOverPhone = () => {
  return (
    <>
      <div id="bodyaddid">
        <Header />
        <FixMenu />
        <section className="main-banner">
          <div
            className="innerpagebanner"
            style={{
              backgroundImage:
                "url(" + "assets/img/inner/payment-collection.jpg" + ")",
              backgroundPosition: "center",
              backgroundSize: "100% auto",
            }}
          >
            <div className="container">
              <div className="row justify-content-center"></div>
            </div>
          </div>
          <Announcement />
        </section>
        <section className="main_sectiods">
          <div className="container main_bdy">
            <div className="row justify-content-center padtops">
              <div className="col-sm-12">
                <div className="row bg_cols">
                  <div className="col-sm-12">
                    <div className="form_div">
                      <div className="tab-content tab_main">
                        <div
                          className="tab-pane fade show active"
                          id="checkcollection"
                        >
                          <div className="row cashcollectioncenter">
                            <legend>Contact Over Phone  <span className="lArea">(NPCL licensed area – Greater Noida) </span></legend>
                            
                            <hr />

                            <div className="innwrper">

                                  <table className="table table-responsive col-sm-12">
                                      <tr>
                                        <td className="col-sm-6"> 24*7 Call Center / Customer Care number  </td>
                                        <td className="col-sm-6">  0120 - 622 6666 </td>
                                      </tr>
                                      <tr>
                                        <td className="col-sm-6"> No Power complaint E-mail  </td>
                                        <td className="col-sm-6"> npc@noidapower.com </td>
                                      </tr>
                                      <tr>
                                        <td className="col-sm-6"> General query complaint E-mail  </td>
                                        <td className="col-sm-6"> crm@noidapower.com </td>
                                      </tr>
                                  </table>
                            </div>
                   
                           
                            <div className="innwrper">
                        
                              <table className="table table-responsive col-sm-12">

                              <tr>

                              <td className="col-sm-2"> Heading </td>
                              <td className="col-sm-3">  Sub-Heading </td>
                              <td className="col-sm-7">
                                  <table className="table table-responsive">
                                    <tr>
                                      <td className="col-sm-5"> Name </td>
                                      <td className="col-sm-4"> Designation </td>
                                      <td className="col-sm-3"> Mobile   </td>                                   
                                    </tr>
                                    
                                </table>
                              </td>
                              </tr>
                              
                              <tr className="trWhite">
                                <td></td><td></td><td></td><td></td>
                              </tr>
                              <tr>
                              <td className="col-sm-2"> Customer Relation </td>
                              <td className="col-sm-3"> General queries / requests / complaints /information </td>
                              <td className="col-sm-7">

                              <div className="contactOver">  
                                <div className="col-sm-5"> Mr. Tarun Raj </div>
                                <div className="col-sm-4"> Dy. Manager - BE&CR </div>
                                <div className="col-sm-3">  9911998254 </div>
                                </div>  

                                <div className="contactOver">  
                                <div className="col-sm-5"> Mr. Prabhat Ranjan </div>
                                <div className="col-sm-4"> Dy. Manager - BE&CR </div>
                                <div className="col-sm-3">  7065049851 </div>
                                </div>  

                                <div className="contactOver">  
                                <div className="col-sm-5"> Mr. Gautam Kumar </div>
                                <div className="col-sm-4"> Manager - BE&CR </div>
                                <div className="col-sm-3">  8700715801 </div>
                                </div>  
                                

                                <div className="contactOver">  
                                <div className="col-sm-5"> Ms. Neha Rai </div>
                                <div className="col-sm-4"> Manager - BE&CR  </div>
                                <div className="col-sm-3">  7065049852 </div>
                                </div>  
                                {/* 
                                  <table className="table table-responsive">
                                    <tr>
                                      <td className="col-sm-5"> Mr. Tarun Raj</td>
                                      <td className="col-sm-4"> Dy. Manager - BE&CR</td>
                                      <td className="col-sm-3"> 9911998254</td>                                   
                                    </tr>                                     <tr>
                                      <td> Mr. Prabhat Ranjan</td>
                                      <td> Dy. Manager - BE&CR</td>
                                      <td> 7065049851</td>                                   
                                    </tr>
                                    <tr>

                                      <td> Mr. Gautam Kumar</td>
                                      <td> Manager - BE&CR </td>
                                      <td> 8287938179 </td>                                   
                                    </tr>
                                    <tr>
                                      <td> Ms. Neha Rai </td>
                                      <td> Manager - BE&CR </td>
                                      <td> 7065049852 </td>                                   
                                    </tr>
                                  </table>*/}        
                              </td>
                              </tr>
                              <tr>
                              <td></td>
                              <td>Overall</td>
                              <td>
                              
                              <div className="contactOver">  
                                <div className="col-sm-5"> Ms. Meghna Dosi </div>
                                <div className="col-sm-4"> Head - BE&CR   </div>
                                <div className="col-sm-3">  7840008873 </div>
                                </div>  
                              {/* <table className="table table-responsive">
                                    <tr>
                                      <td className="col-sm-5">  Ms. Meghna Dosi  </td>
                                      <td className="col-sm-4">  Head - BE&CR </td>
                                      <td className="col-sm-3"> 7840008873</td>                                   
                                    </tr>
                                  </table>    */}
                              </td>
                              </tr>
                      </table>
                    </div>

                          <div className="innwrper">
                            
                            <div className="row">
                            
                              <div className="col-sm-2"><br/><br/><br/><br/><br/> New Connection - Operations </div>
                              
                              <div className="col-sm-10">
                                
                                <div className="contactOver">  
                                  <div className="col-sm-4"> New Connection(LT - Upto 50 KW) </div>
                                  <div className="col-sm-3">Mr. Amit Tripathi </div>
                                  <div className="col-sm-3"> Executive - Operations  </div>
                                  <div className="col-sm-2">  9911998234 </div>
                                </div>

                                <div className="contactOver">  
                                  <div className="col-sm-4">  New Connection(HT - > 50  KW) </div>
                                  <div className="col-sm-3">  Mr. Udit Kulshrestha   </div>
                                  <div className="col-sm-3">  Assistant Manager - Operations  </div>
                                  <div className="col-sm-2">  8505952424  </div>
                                </div>  

                                <div className="contactOver">  
                                  <div className="col-sm-4"> Coversion of single point connection to multi point connection for multi-storied building </div>
                                  <div className="col-sm-3"> Mr. Tarun Chauhan   </div>
                                  <div className="col-sm-3"> Sr. Executive - Operations   </div>
                                  <div className="col-sm-2">  9911998208 </div>
                                </div>  


                                  <div className="contactOver">  
                                    <div className="col-sm-4">  New Connection Head </div>
                                    <div className="col-sm-3"> Mr. Jitendra Dhamat  </div>
                                    <div className="col-sm-3"> Sr. Manager - Operations   </div>
                                    <div className="col-sm-2">  8743009894 </div>
                                </div>  
                                
                              </div>
                            </div>
                          </div>
                              
                       

                          <div className="innwrper">
                            
                            <div className="row">
                            
                              <div className="col-sm-2">  <br/><br/><br/><br/><br/><br/> Operations & Maintenance - Zone-1 </div>
                              
                              <div className="col-sm-10">

                                
                                <div className="contactOver">  
                                  <div className="col-sm-4"> Surajpur-1 (Site C/Site B/ Udyog Vihar/Udyog  kendra/B2P area/Ecotech-3 etc.) </div>
                                  <div className="col-sm-3"> Mr. Biswaranjan Gouda </div>
                                  <div className="col-sm-3"> Asst. Manager - Operations   </div>
                                  <div className="col-sm-2">  7834807022 </div>
                                </div>

                                <div className="contactOver">  
                                  <div className="col-sm-4">  Surajpur-2 (Surajpur/Kuleshra/Tilapta/Devla/ Jalpura/ Haldauni/Habibpur/ Thapkhera/Boraki/Pali/Ghori etc.) </div>
                                  <div className="col-sm-3">  Mr. Rahul Singh   </div>
                                  <div className="col-sm-3">  Asst. Manager- Operations  </div>
                                  <div className="col-sm-2"> 8744052917   </div>
                                </div>  

 

                                <div className="contactOver">  
                                  <div className="col-sm-4"> Greater Noida West (Societies of GNW/Ecotech-12/ Techzon-4/Sec-10/Ithehra etc.) </div>
                                  <div className="col-sm-3">  Mr. Inder Pal Singh Lodhi    </div>
                                  <div className="col-sm-3">  Dy. Manager - Operations   </div>
                                  <div className="col-sm-2">  8743009896 </div>
                                </div>  


                                  <div className="contactOver">  
                                    <div className="col-sm-4">  Zone-1 Head  </div>
                                    <div className="col-sm-3"> Mr. Gaurav Sharma </div>
                                    <div className="col-sm-3"> Sr. Manager - Operations   </div>
                                    <div className="col-sm-2">  8743009894 </div>
                                </div>  
                                
                              </div>
                            </div>
                          </div>
                              
{/* 
                            <div className="innwrper">
                            <table className="table table-responsive col-sm-12">
                              <tr>
                              <td className="col-sm-2"> Operations & Maintenance - Zone-1</td>
                              <td className="col-sm-10">
                                  <table className="table table-responsive">
                                    <tr>
                                      <td className="col-sm-5"> Surajpur-1 (Site C/Site B/ Udyog Vihar/Udyog  kendra/B2P area/Ecotech-3 etc.)</td>
                                      <td className="col-sm-4"> Mr. Biswaranjan Gouda</td>
                                      <td className="col-sm-3"> Asst. Manager - Operations  </td>     
                                      <td className="col-sm-3"> 7834807022 </td>                                 
                                    </tr>
                                    <tr>
                                      <td>  Surajpur-2 (Surajpur/Kuleshra/Tilapta/Devla/ Jalpura/ Haldauni/Habibpur/ Thapkhera/Boraki/Pali/Ghori etc.)</td>
                                      <td>  Mr. Rahul Singh </td>
                                      <td>  Asst. Manager- Operations  </td>     
                                      <td>  8744052917  </td>                                   
                                    </tr>
                                    <tr>
                                      <td> Greater Noida West (Societies of GNW/Ecotech-12/ Techzon-4/Sec-10/Ithehra etc.)</td>
                                      <td> Mr. Inder Pal Singh Lodhi  </td>                                      
                                      <td> Dy. Manager - Operations</td>     
                                      <td> 8743009896</td>                                   
                                    </tr>
                                    <tr>
                                      <td> Zone-1 Head </td>
                                      <td> Mr. Gaurav Sharma</td>
                                      <td> Sr. Manager - Operations</td>     
                                      <td> 9990046407</td>                                   
                                    </tr>
                                  </table>        
                              </td>
                              </tr>
                      </table>
                            </div>
 */}


                      <div className="innwrper">
                            
                            <div className="row">
                            
                              <div className="col-sm-2">  <br/><br/><br/><br/><br/><br/> Operations & Maintenance - Zone-2 </div>
                              
                              <div className="col-sm-10">

                                
                                <div className="contactOver">  
                                  <div className="col-sm-4">Urban-1(Alpha/Beta/Gamma/Delta/ Eta/Zeta/Tughalpur/KP1/ KP2/KP3/KP4 etc.) </div>
                                  <div className="col-sm-3"> Mr. Tarun Chauhan  </div>
                                  <div className="col-sm-3"> Senior
                                  Executive-Operations   </div>
                                  <div className="col-sm-2">  9911998208 </div>
                                </div>

                                <div className="contactOver">  
                                  <div className="col-sm-4">  Urban-2 & Kasna (Sigma/ Omicron/ ZU/MU/Chi/Builders area/swarn Nagri /Site-4/Site-5/Ecotech Ext-1/Ecotech-6 etc.) </div>
                                  <div className="col-sm-3"> Mr. Pawan Gautam   </div>
                                  <div className="col-sm-3"> Dy. Manager - Operations </div>
                                  <div className="col-sm-2"> 9540060874   </div>
                                </div>  



                                <div className="contactOver">  
                                  <div className="col-sm-4"> Zone-2-Head </div>
                                  <div className="col-sm-3">  Mr. Pankaj Palawat     </div>
                                  <div className="col-sm-3">  Sr. Manager - Operations   </div>
                                  <div className="col-sm-2"> 8287238929</div>
                                </div>  

                                
                              </div>
                            </div>
                          </div>
{/* 
                            <div className="innwrper">
                            <table className="table table-responsive col-sm-12">
                              <tr>
                              <td className="col-sm-2"> Operations & Maintenance - Zone-2 </td>
                              <td className="col-sm-10">
                                  <table className="table table-responsive">
                                    <tr>
                                      <td className="col-sm-5"> Urban-1(Alpha/Beta/Gamma/Delta/ Eta/Zeta/Tughalpur/KP1/ KP2/KP3/KP4 etc.)</td>
                                      <td className="col-sm-4"> Mr. Amandeep Singh</td>
                                      <td className="col-sm-3"> Executive - Operations  </td>     
                                      <td className="col-sm-3"> 8750068236 </td>                                 
                                    </tr>
                                    <tr>
                                      <td> Urban-2 & Kasna (Sigma/ Omicron/ ZU/MU/Chi/Builders area/swarn Nagri /Site-4/Site-5/Ecotech Ext-1/Ecotech-6 etc.)</td>
                                      <td> Mr. Pawan Gautam </td>
                                      <td>  Dy. Manager - Operations </td>     
                                      <td> 9540060874 </td>                                   
                                    </tr>
                                    <tr>
                                      <td> Zone-2-Head</td>
                                      <td> Mr. Pankaj Palawat  </td>                                      
                                      <td> Sr. Manager - Operations </td>     
                                      <td> 8287238929 </td>                                   
                                    </tr>
                                   
                                  </table>        
                              </td>
                              </tr>
                      </table>
                            </div>
 

                            <div className="innwrper">
                            <table className="table table-responsive col-sm-12">
                              <tr>
                              <td className="col-sm-2"> Commercial Services </td>
                              <td className="col-sm-10">
                                  <table className="table table-responsive">
                                    <tr>
                                      <td className="col-sm-5"> Reconnection / Disconnection</td>
                                      <td className="col-sm-4"> Mr. Sunil Kumar Sharma</td>
                                      <td className="col-sm-3"> Asst. Manager - Commercial </td>     
                                      <td className="col-sm-3"> 9990046403 </td>                                 
                                    </tr>
                                    <tr>
                                      <td> Reconnection / Disconnection (Rural)</td>
                                      <td>  Mr. Tarun Goel </td>     
                                      <td> Manager - Loss Control Cell</td>
                                      <td>7065049847</td>
                                    </tr>
                                    <tr>
                                      <td> Meter reading & Billing</td>
                                      <td>  Mr. Nikhil Garg </td>     
                                      <td> DGM - Commercial</td>
                                      <td>9990046406</td>
                                    </tr>
                                    <tr>
                                      <td> Commercial services (Name mutation/load reduction/category transfer/Permanent disconnection/Security deposit refund) </td>
                                      <td> Mr. Abhishake Jain </td>                                      
                                      <td> DGM-Commercial </td>     
                                      <td> 9718804962</td>                                   
                                    </tr>

                                    <tr>
                                      <td> Overall – Billing and Collection</td>
                                      <td> Mr. Harinder Singh </td>                                      
                                      <td> Head - Commercial </td>     
                                      <td> 9625313294 </td>                                   
                                    </tr>
                                   
                                  </table>        
                              </td>
                              </tr>
                      </table>
                    </div>*/}


                    <div className="innwrper">
                            
                            <div className="row">
                            
                              <div className="col-sm-2">  <br/><br/><br/><br/><br/><br/> Commercial Services </div>
                              
                              <div className="col-sm-10">

                                
                                <div className="contactOver">  
                                  <div className="col-sm-4">  Reconnection / Disconnection </div>
                                  <div className="col-sm-3"> Mr. Sunil Kumar Sharma </div>
                                  <div className="col-sm-3"> Asst. Manager - Commercial    </div>
                                  <div className="col-sm-2"> 9990046403  </div>
                                </div>

                                <div className="contactOver">  
                                  <div className="col-sm-4">  Reconnection / Disconnection (Rural) </div>
                                  <div className="col-sm-3"> Mr. Tarun Goel   </div>
                                  <div className="col-sm-3">  Manager - Loss Control Cell </div>
                                  <div className="col-sm-2"> 7065049847   </div>
                                </div>  

                                <div className="contactOver">  
                                  <div className="col-sm-4"> Meter reading & Billing </div>
                                  <div className="col-sm-3"> Mr. Nikhil Garg    </div>
                                  <div className="col-sm-3"> DGM - Commercial </div>
                                  <div className="col-sm-2"> 9990046406  </div>
                                </div>  


                                    <div className="contactOver">  
                                  <div className="col-sm-4"> Commercial services (Name mutation/load reduction/category transfer/Permanent disconnection/Security deposit refund) </div>
                                  <div className="col-sm-3">  Mr. Abhishake Jain     </div>
                                  <div className="col-sm-3">  DGM-Commercial   </div>
                                  <div className="col-sm-2">  9718804962 </div>
                                </div>                                     


                                <div className="contactOver">  
                                  <div className="col-sm-4"> Overall – Billing and Collection </div>
                                  <div className="col-sm-3">  Mr. Harinder Singh     </div>
                                  <div className="col-sm-3">  Head - Commercial   </div>
                                  <div className="col-sm-2">  9625313294 </div>
                                </div>  

                                
                              </div>
                            </div>
                          </div>



                          <div className="innwrper">
                            
                            <div className="contactOver">
                            
                                  <div className="col-sm-2">  Metering  </div>
                              
                                  <div className="col-sm-10">
                                    <div className="row">  
                                      <div className="col-sm-4">  Meter Related Concerns </div>
                                      <div className="col-sm-3"> Mr. Navin Kumar </div>
                                      <div className="col-sm-3"> Manager - Automation    </div>
                                      <div className="col-sm-2"> 9891701264   </div>
                                    </div>

                                  </div>
                              </div>
                              

                                <div className="contactOver">
                            
                                    <div className="col-sm-2">   Transformer - Operations  </div>
                            
                                  <div className="col-sm-10">
                                        <div className="row">  
                                          <div className="col-sm-4">  Transformer Related Concerns </div>
                                          <div className="col-sm-3">Mr. Kajal Dey </div>
                                          <div className="col-sm-3"> Asst. Manager - Operations   </div>
                                          <div className="col-sm-2"> 9718804967 </div>
                                        </div>
                                      </div>
                                  </div>


                                  <div className="contactOver">
                            
                                    <div className="col-sm-2">   Loss control cell - Operations  </div>
                    
                                <div className="col-sm-10">
                                      <div className="row">  
                                        <div className="col-sm-4">  Report Electricity theft  </div>
                                        <div className="col-sm-3"> Mr. Chandan Dhar  </div>
                                        <div className="col-sm-3"> Manager - Operations   </div>
                                        <div className="col-sm-2"> 8750068226 </div>
                                      </div>
                                    </div>
                                 </div>
                          
                            <div className="contactOver">
                            
                            <div className="col-sm-2">   Loss control cell - Operations  </div>
                    
                            <div className="col-sm-10">
                                <div className="row">  
                                  <div className="col-sm-4">  Report Electricity theft  </div>
                                  <div className="col-sm-3"> Mr. Avnesh Kumar  </div>
                                  <div className="col-sm-3"> Manager - Operations   </div>
                                  <div className="col-sm-2"> 8744052921 </div>
                                </div>
                              </div>
                          </div>
    
                          </div>


                          <div className="innwrper" content="noindex">
                                <table className="table table-responsive col-sm-12">
                                          <tr>
                                              <td className="col-sm-6">
                                            24*7 Call Center / Customer Care number 
                             
                                              </td>
                                              <td  className="col-sm-6">
                                            0120 - 622 6666
                                                </td>
                                          </tr>
                                          <tr>
                                              <td className="col-sm-6">
                                              No Power complaint E-mail
                             
                                              </td>
                                              <td  className="col-sm-6">
                                              npc@noidapower.com
                                                </td>
                                          </tr>
                                          <tr>
                                              <td className="col-sm-6">
                                              General query complaint E-mail
                             
                                              </td>
                                              <td  className="col-sm-6">
                                              crm@noidapower.com
                                                </td>
                                          </tr>
                                          <tr><td></td><td></td></tr>
                                        </table>
                                        </div>


                  {/*
                    <div className="innwrper" content="noindex">
                                <table className="table table-responsive col-sm-12">
                                          <tr>
                                              <td className="col-sm-6">
                                            24*7 Call Center / Customer Care number 
                             
                                              </td>
                                              <td  className="col-sm-6">
                                            0120 - 622 6666
                                                </td>
                                          </tr>
                                          <tr>
                                              <td className="col-sm-6">
                                              No Power complaint E-mail
                             
                                              </td>
                                              <td  className="col-sm-6">
                                              npc@noidapower.com
                                                </td>
                                          </tr>
                                          <tr>
                                              <td className="col-sm-6">
                                              General query complaint E-mail
                             
                                              </td>
                                              <td  className="col-sm-6">
                                              crm@noidapower.com
                                                </td>
                                          </tr>
                                          <tr><td></td><td></td></tr>
                                        </table>
                            <table className="table table-responsive col-sm-12">

                              <tr>
                                      <td className="col-sm-2"> Metering </td>
                                      <td className="col-sm-3"> Meter Related Concerns </td>
                                      <td className="col-sm-3"> Mr. Navin Kumar  </td>     
                                      <td className="col-sm-2"> Manager - Automation</td>                                 
                                      <td className="col-sm-2"> 9891701264  </td>       
                                    </tr>
                                    <tr>
                                      <td> Transformer - Operations </td>
                                      <td> Transformer Related Concerns </td>
                                      <td> Mr. Kajal Dey  </td>     
                                      <td> Asst. Manager - Operations </td> 
                                      <td> 9718804967 </td>               
                                    </tr>
                                    <tr>
                                      <td> Loss control cell - Operations </td>
                                      <td> Report Electricity theft </td>
                                      <td>  Mr. Chandan Dhar </td>     
                                      <td> Manager - Operations</td>
                                      <td>8750068226</td>
       
                                    </tr>
                                    <tr>
                                      <td> Loss control cell - Operations </td>
                                      <td>Report Electricity theft </td>                                      
                                      <td> Mr. Avnesh Kumar </td>
                                      <td> Manager - Operations </td>
                                      <td> 8744052921 </td>                             
                                    </tr>              
                                  </table>        
                           </div>

                             <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Reconnection/Disconnection
                                </div>
                                <div className="contact">
                                  Mr. Sunil Kumar Sharma, Assistant Manager
                                  (Commercial) <br />
                                  +91-9990046403
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Single point Connection to Multipoint
                                  Connections Conversion for Multi-Storied
                                  Buildings/Gated Residential Colonies
                                </div>
                                <div className="contact">
                                  Mr. Tarun Chauhan (Senior
                                  Executive-Operations)
                                  <br />
                                  0120-6226606/2333506/2333507
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  New Service Connections
                                </div>
                                <div className="contact">
                                  Mr. Ankur, Assistant Manager (Operations) (HT
                                  Connections) <br />
                                  +91-8750068222 <br />
                                  <br /> Mr. Amit Tripathi, Engineer
                                  (Operations)(LT Connections) <br />
                                  +91-9911998234
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Theft report of electricity or of any
                                  equipment belonging to NPCL
                                </div>
                                <div className="contact">
                                  Mr. Chandan Dhar, Manager (LCC) +91-8750068226{" "}
                                  <br />
                                  <br /> Mr. Avnesh Kumar, Dy. Manager (LCC)
                                  +91-8744052921
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Meter-related queries or High Tension
                                  Equipment Testing
                                </div>
                                <div className="contact">
                                  Mr. Navin Kumar, Manager (Operations)
                                  +91-9891701264
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Transformer Related
                                </div>
                                <div className="contact">
                                 Mr. Kajal Dey, Assistant Manager
                                  (Operations)
                                  <br /> +91-9718804967
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Urban Division-I(Alpha, Beta, Gama, Delta &
                                  KP-I,II and III, Zeta, Eta)
                                </div>
                                <div className="contact">
                                  Amandeep Singh, Executive (Operations) +91- 8750068236
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Urban Division-II(Sigma, Omicron, Zu, Mu,
                                  Chi-III, Chi-IV, Chi-V, Swarna Nagri, Builders
                                  Area)
                                </div>
                                <div className="contact">
                                  Pavan Gautam, Assistant Manager (Operations)
                                  +91-9540060874
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Surajpur I Division (Site -B,C,Udyog Vihar,B2P
                                  Area,Udyog Kendra,Ecotech-3,Industrial Area
                                  and villages with these area )
                                </div>
                                <div className="contact">
                                  Krishna Chandra Kumar, Sr. Executive
                                  (Operations) +91-7835045065
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Surajpur II Division (Surajpur, Tilapta,
                                  Devla, Jalpura, Haldauni, Habibpur, Thapkhera,
                                  Boraki, Pali, Ghori, etc.)
                                </div>
                                <div className="contact">
                                  Amit Kumar, Assistant Manager (Operations)
                                  +91-9911998247
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Kasna Division (Site-IV, Site-V, Ecotech
                                  Extension -1, Ecotech-6)
                                </div>
                                <div className="contact">
                                  Shubhajit Dhar, Sr. Executive (Operations)
                                  +91-8744052902
                                </div>
                              </div>
                            </div>
                            <div className="innwrper">
                              <div className="contactOver">
                                <div className="contact">
                                  Greater Noida West
                                </div>
                                <div className="contact">
                                  Mr. Inder Pal Singh Lodhi, Assistant Manager
                                  (Operations) +91-8743009896
                                </div>
                              </div>
                            </div>*/}
                            <div style={{ marginTop: "10px" }}>
                              <a href="#" style={{ textDecoration: "none" }}>
                                Calls to NPCL officials shall be accepted during
                                office hours.
                              </a>
                            </div> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactOverPhone;
